import { useEffect, useState, type ReactNode } from 'react'
import { initAuthSessionAfterHydration } from '@/auth/initAuthSession'
import { useAuthStore } from '@/stores/authStore'

/**
 * Bloqueia a UI até o bootstrap de sessão terminar (evita loop de redirects).
 */
export function AuthBootstrap({ children }: { children: ReactNode }) {
  const [bootstrapped, setBootstrapped] = useState(false)
  const authReady = useAuthStore((s) => s.authReady)

  useEffect(() => {
    let cancelled = false

    // Evita tela preta/spinner infinito se persist ou refresh travar
    const safetyTimer = window.setTimeout(() => {
      if (cancelled) return
      const { authReady, markAuthSessionReady } = useAuthStore.getState()
      if (!authReady) markAuthSessionReady()
      setBootstrapped(true)
    }, 8_000)

    void initAuthSessionAfterHydration().finally(() => {
      if (!cancelled) setBootstrapped(true)
    })

    return () => {
      cancelled = true
      window.clearTimeout(safetyTimer)
    }
  }, [])

  if (!bootstrapped || !authReady) {
    return (
      <div
        className='flex min-h-screen items-center justify-center bg-[#08090a] text-[#a0a0a0]'
        role='status'
        aria-label='Carregando'
      >
        <div className='h-10 w-10 animate-spin rounded-full border-2 border-[#5e6ad2] border-t-transparent' />
      </div>
    )
  }

  return <>{children}</>
}
